'use client'

import { useContext } from 'react'
import { PushContext, PushContextType } from '@/context/PushContext'
import { getPermission } from '@/libs/Pushes/pushes.lib'
import Popup from '../Popup/Popup'
import styles from './PushPopup.module.scss'
import { notifyError } from '@/libs/bugsnag/bugsnag'
import { getAppConfig } from '@/config/config'
import AppContext from '@/types/context'
import { FeatureFlagService } from '@/services/api/unleash/FeatureFlag.service'
import { FF_WEBPUSH } from '@/config/featureFlags'
const config = getAppConfig()
const basePath = config.basePath

const PushPopup = ({ context }: { context: AppContext }) => {
  const pushContext = useContext(PushContext)
  if (!FeatureFlagService.isFeatureFlagEnabled(context?.featureFlags, FF_WEBPUSH)) {
    return null
  }

  const { updateIsOpen, updatePermission, isOpen } = pushContext as PushContextType

  const onAgreeCallback = () => {
    updateIsOpen(false)
    getPermission(updatePermission)
      .then(() => {
        if (globalThis.window.location.pathname !== `${basePath}/browserpush/`) {
          globalThis.window.location.href = `${basePath}/browserpush/`
        }
      })
      .catch((error) => {
        notifyError('pushDelivery not available', {
          scope: PushPopup.name,
          message: error.message,
          stack: error.stack,
        })
        globalThis.window.alert('Bitte erlauben Sie Push Nachrichten in den Einstellungen des Browsers.')
      })
  }

  const onDisagreeCallback = () => {
    updateIsOpen(false)
    if (localStorage.getItem('askDenied') === 'true') {
      localStorage.setItem('dontAskAgain', 'true')
    }
    localStorage.setItem('askDenied', 'true')
    localStorage.setItem('lastDeniedDate', new Date().toString())
  }

  return (
    <>
      {isOpen && (
        <Popup title="NTV SPORT Browser Push" setIsOpen={updateIsOpen}>
          <p>
            Möchten Sie künftig direkt per Browser-Benachrichtigung über die wichtigsten Sport-Nachrichten informiert
            werden?
          </p>
          <div className={styles.footer}>
            <button className="button secondary" onClick={onDisagreeCallback}>
              Nein, danke
            </button>
            <button className="button primary" onClick={onAgreeCallback}>
              Benachrichtigungen aktivieren
            </button>
          </div>
        </Popup>
      )}
    </>
  )
}

export default PushPopup
